import React, { useState } from "react";
import {
    FiX, FiUser, FiPlus, FiList, FiSearch, FiBan,
    FiSave, FiLoader, FiClock, FiCalendar, FiPhone,
    FiTag, FiToggleLeft, FiToggleRight
} from "react-icons/fi";
import {BsBan} from "react-icons/bs";

const QuickCreateModal = ({
                              open,
                              onClose,
                              quickForm,
                              setQuickForm,
                              servicesList,
                              staffList,
                              availableSlots,
                              slotsLoading,
                              isNewCustomer,
                              setIsNewCustomer,
                              customerSearch,
                              setCustomerSearch,
                              filteredCustomers,
                              handleCustomerSearch,
                              selectCustomer,
                              serviceSearch,
                              setServiceSearch,
                              showServiceDropdown,
                              setShowServiceDropdown,
                              optServiceSearch,
                              setOptServiceSearch,
                              showOptServiceDropdown,
                              setShowOptServiceDropdown,
                              creating,
                              onSubmit,
                              onToggleBreak,
                          }) => {
    if (!open) return null;

    const filteredServices = servicesList.filter(s =>
        s.name?.toLowerCase().includes(serviceSearch.toLowerCase())
    );
    const filteredOptServices = servicesList.filter(s =>
        s.name?.toLowerCase().includes(optServiceSearch.toLowerCase())
    );

    const selectedServiceName = servicesList.find(s => String(s.id) === String(quickForm.serviceId))?.name || "";
    const selectedOptName = servicesList.find(s => String(s.id) === String(quickForm.optionalService1))?.name || "";

    return (
        <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-navy-900/70 backdrop-blur-md">
            <div
                className="bg-white dark:bg-navy-800 rounded-3xl shadow-2xl w-full max-w-2xl max-h-[92vh] flex flex-col overflow-hidden"
                style={{ animation: "scaleIn 0.2s ease-out" }}
            >
                {/* Header */}
                <div className="p-5 bg-gray-50 dark:bg-navy-900 flex justify-between items-center border-b border-gray-100 dark:border-navy-700">
                    <div>
                        <h2 className="text-xl font-bold text-navy-700 dark:text-white flex items-center gap-2">
                            <FiPlus className="text-brand-500" /> Yeni Randevu Oluştur
                        </h2>
                        <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 flex items-center gap-1.5">
                            <FiClock size={13} className="text-brand-500" />
                            {quickForm.date} — {quickForm.time}
                        </p>
                    </div>
                    <button
                        onClick={onClose}
                        className="p-2 rounded-xl text-gray-400 hover:text-red-500 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all"
                    >
                        <FiX size={22} />
                    </button>
                </div>

                {/* Body */}
                <div className="p-5 overflow-y-auto flex-1 space-y-5"
                     style={{ scrollbarWidth: "thin" }}>

                    {/* Personel */}
                    <div>
                        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                            Personel *
                        </label>
                        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                            {staffList.map(s => (
                                <button
                                    key={s.id}
                                    type="button"
                                    onClick={() => setQuickForm({ ...quickForm, staffId: String(s.id), time: "" })}
                                    className={`py-2.5 px-3 text-xs font-bold rounded-xl border transition-all text-left
                    ${String(quickForm.staffId) === String(s.id)
                                        ? "border-brand-500 bg-brand-50 dark:bg-brand-500/10 text-brand-600 dark:text-white shadow-sm"
                                        : "border-gray-200 dark:border-navy-600 bg-gray-50 dark:bg-navy-900 text-gray-600 dark:text-gray-400 hover:border-brand-300"}`}
                                >
                                    <div className="flex items-center gap-2">
                                        <div className="w-7 h-7 rounded-lg bg-brand-500/10 dark:bg-brand-500/20 text-brand-600 dark:text-brand-400 flex items-center justify-center font-bold text-[10px]">
                                            {((s.name || "")[0] + (s.surname || "")[0]).toUpperCase()}
                                        </div>
                                        <span className="truncate">{s.name} {s.surname}</span>
                                    </div>
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Tarih */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                <FiCalendar className="inline mr-1" /> Tarih *
                            </label>
                            <input
                                type="date"
                                value={quickForm.date}
                                onChange={e => setQuickForm({ ...quickForm, date: e.target.value, time: "" })}
                                className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl px-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                            />
                        </div>

                        {/* Saat Seçimi */}
                        <div>
                            <div className="flex items-center justify-between mb-2">
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                                    <FiClock className="inline mr-1" /> Saat *
                                </label>
                                <button
                                    type="button"
                                    onClick={() => setQuickForm({ ...quickForm, isManual: !quickForm.isManual })}
                                    className="text-[10px] font-bold flex items-center gap-1 text-brand-500 hover:text-brand-600"
                                >
                                    {quickForm.isManual ? <FiToggleRight size={14}/> : <FiToggleLeft size={14}/>}
                                    Manuel
                                </button>
                            </div>

                            {quickForm.isManual ? (
                                <div className="flex gap-2">
                                    <input
                                        type="time"
                                        value={quickForm.time}
                                        onChange={e => setQuickForm({ ...quickForm, time: e.target.value })}
                                        className="flex-1 bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl px-3 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                    />
                                    <input
                                        type="number"
                                        placeholder="Süre (dk)"
                                        value={quickForm.customDuration}
                                        onChange={e => setQuickForm({ ...quickForm, customDuration: e.target.value })}
                                        className="w-28 bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl px-3 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                    />
                                </div>
                            ) : slotsLoading ? (
                                <div className="flex items-center gap-2 px-4 py-3 bg-gray-50 dark:bg-navy-900 rounded-xl border border-gray-200 dark:border-navy-700">
                                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
                                    <span className="text-xs text-gray-500">Saatler yükleniyor...</span>
                                </div>
                            ) : availableSlots.length === 0 ? (
                                <div className="px-4 py-3 bg-amber-50 dark:bg-amber-900/10 rounded-xl border border-amber-100 dark:border-amber-800/30 text-xs text-amber-600 dark:text-amber-400 font-medium">
                                    Bu tarih için müsait saat bulunamadı.
                                </div>
                            ) : (
                                <div className="flex flex-wrap gap-1.5 p-3 bg-gray-50 dark:bg-navy-900 rounded-xl border border-gray-200 dark:border-navy-700 max-h-32 overflow-y-auto" style={{ scrollbarWidth: "thin" }}>
                                    {availableSlots.map(slot => (
                                        <button
                                            key={slot}
                                            type="button"
                                            onClick={() => setQuickForm({ ...quickForm, time: slot })}
                                            className={`px-3 py-1.5 rounded-lg text-xs font-bold transition-all
                        ${quickForm.time === slot
                                                ? "bg-brand-500 text-white shadow-md shadow-brand-500/30"
                                                : "bg-white dark:bg-navy-800 text-gray-600 dark:text-gray-300 border border-gray-200 dark:border-navy-600 hover:border-brand-400"}`}
                                        >
                                            {slot.substring(0, 5)}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Hizmet */}
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {/* Ana Hizmet */}
                        <div className="relative">
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Ana Hizmet *
                            </label>
                            <div className="relative">
                                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
                                <input
                                    type="text"
                                    placeholder={selectedServiceName || "Hizmet ara..."}
                                    value={serviceSearch}
                                    onFocus={() => setShowServiceDropdown(true)}
                                    onChange={e => { setServiceSearch(e.target.value); setShowServiceDropdown(true); }}
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                            {showServiceDropdown && filteredServices.length > 0 && (
                                <div className="absolute z-50 w-full mt-1 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl shadow-xl max-h-40 overflow-y-auto" style={{ scrollbarWidth: "thin" }}>
                                    {filteredServices.map(s => (
                                        <button
                                            key={s.id}
                                            type="button"
                                            onMouseDown={() => {
                                                setQuickForm({ ...quickForm, serviceId: String(s.id) });
                                                setServiceSearch(s.name);
                                                setShowServiceDropdown(false);
                                            }}
                                            className="w-full text-left px-4 py-2.5 text-sm hover:bg-brand-50 dark:hover:bg-navy-700 text-navy-700 dark:text-gray-300 flex justify-between items-center"
                                        >
                                            <span>{s.name}</span>
                                            {s.duration && <span className="text-xs text-gray-400">{s.duration} dk</span>}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Opsiyonel Hizmet */}
                        <div className="relative">
                            <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">
                                Ek Hizmet <span className="text-gray-400 font-normal">(opsiyonel)</span>
                            </label>
                            <div className="relative">
                                <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14} />
                                <input
                                    type="text"
                                    placeholder={selectedOptName || "Ek hizmet ara..."}
                                    value={optServiceSearch}
                                    onFocus={() => setShowOptServiceDropdown(true)}
                                    onChange={e => { setOptServiceSearch(e.target.value); setShowOptServiceDropdown(true); }}
                                    className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                />
                            </div>
                            {showOptServiceDropdown && filteredOptServices.length > 0 && (
                                <div className="absolute z-50 w-full mt-1 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl shadow-xl max-h-40 overflow-y-auto" style={{ scrollbarWidth: "thin" }}>
                                    <button
                                        type="button"
                                        onMouseDown={() => { setQuickForm({ ...quickForm, optionalService1: "" }); setOptServiceSearch(""); setShowOptServiceDropdown(false); }}
                                        className="w-full text-left px-4 py-2.5 text-sm text-gray-400 hover:bg-gray-50 dark:hover:bg-navy-700 italic"
                                    >— Ek hizmet yok</button>
                                    {filteredOptServices.map(s => (
                                        <button
                                            key={s.id}
                                            type="button"
                                            onMouseDown={() => {
                                                setQuickForm({ ...quickForm, optionalService1: String(s.id) });
                                                setOptServiceSearch(s.name);
                                                setShowOptServiceDropdown(false);
                                            }}
                                            className="w-full text-left px-4 py-2.5 text-sm hover:bg-brand-50 dark:hover:bg-navy-700 text-navy-700 dark:text-gray-300 flex justify-between items-center"
                                        >
                                            <span>{s.name}</span>
                                            {s.duration && <span className="text-xs text-gray-400">{s.duration} dk</span>}
                                        </button>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Müşteri */}
                    <div>
                        <div className="flex items-center justify-between mb-3">
                            <label className="text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                                <FiUser className="inline mr-1" /> Müşteri *
                            </label>
                            <button
                                type="button"
                                onClick={() => {
                                    setIsNewCustomer(!isNewCustomer);
                                    setQuickForm({ ...quickForm, customerId: "", name: "", surname: "", phone: "", birthDate: "", tag: "" });
                                    setCustomerSearch("");
                                }}
                                className={`flex items-center gap-1.5 px-3 py-1.5 rounded-xl text-xs font-bold transition-all border
                  ${isNewCustomer
                                    ? "bg-gray-50 dark:bg-navy-900 border-gray-200 dark:border-navy-600 text-gray-600 dark:text-gray-400"
                                    : "bg-brand-50 dark:bg-brand-500/10 border-brand-200 dark:border-brand-500/30 text-brand-600 dark:text-brand-400"}`}
                            >
                                {isNewCustomer ? <><FiList size={13}/> Kayıtlı Seç</> : <><FiPlus size={13}/> Yeni Kayıt</>}
                            </button>
                        </div>

                        {isNewCustomer ? (
                            <div className="p-4 bg-gray-50 dark:bg-navy-900 rounded-2xl border border-gray-200 dark:border-navy-700 space-y-3">
                                <div className="grid grid-cols-2 gap-3">
                                    <input
                                        type="text"
                                        placeholder="İsim *"
                                        value={quickForm.name}
                                        onChange={e => setQuickForm({ ...quickForm, name: e.target.value })}
                                        className="bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl px-4 py-2.5 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                    />
                                    <input
                                        type="text"
                                        placeholder="Soyisim *"
                                        value={quickForm.surname}
                                        onChange={e => setQuickForm({ ...quickForm, surname: e.target.value })}
                                        className="bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl px-4 py-2.5 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                    />
                                </div>
                                <div className="relative">
                                    <FiPhone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14}/>
                                    <input
                                        type="text"
                                        placeholder="Telefon (5XX...) *"
                                        value={quickForm.phone}
                                        onChange={e => setQuickForm({ ...quickForm, phone: e.target.value })}
                                        className="w-full bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-2.5 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                    />
                                </div>
                                <div className="grid grid-cols-2 gap-3">
                                    <div>
                                        <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wide block mb-1">Doğum Tarihi</label>
                                        <input
                                            type="date"
                                            value={quickForm.birthDate}
                                            onChange={e => setQuickForm({ ...quickForm, birthDate: e.target.value })}
                                            className="w-full bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl px-3 py-2.5 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-[10px] font-bold text-gray-400 uppercase tracking-wide block mb-1 flex items-center gap-1"><FiTag size={10}/> Etiket</label>
                                        <input
                                            type="text"
                                            placeholder="Örn: VIP, Öğrenci..."
                                            value={quickForm.tag}
                                            onChange={e => setQuickForm({ ...quickForm, tag: e.target.value })}
                                            className="w-full bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl px-3 py-2.5 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                        />
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="relative">
                                <div className="relative">
                                    <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={14}/>
                                    <input
                                        type="text"
                                        placeholder="İsim, soyisim veya telefon ile ara..."
                                        value={customerSearch}
                                        onChange={handleCustomerSearch}
                                        className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl pl-9 pr-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all"
                                    />
                                </div>
                                {quickForm.customerId && (
                                    <div className="mt-2 flex items-center gap-2 px-3 py-2 bg-brand-50 dark:bg-brand-500/10 rounded-xl border border-brand-200 dark:border-brand-500/30">
                                        <div className="w-6 h-6 rounded-md bg-brand-500 flex items-center justify-center text-white font-bold text-[10px]">
                                            {(quickForm.name[0] || "?").toUpperCase()}
                                        </div>
                                        <span className="text-sm font-bold text-brand-600 dark:text-brand-400">{quickForm.name} {quickForm.surname}</span>
                                        <button type="button" onClick={() => { setQuickForm({ ...quickForm, customerId: "", name: "", surname: "", phone: "" }); setCustomerSearch(""); }} className="ml-auto text-gray-400 hover:text-red-500">
                                            <FiX size={14}/>
                                        </button>
                                    </div>
                                )}
                                {filteredCustomers.length > 0 && (
                                    <div className="absolute z-50 w-full mt-1 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 rounded-xl shadow-xl max-h-48 overflow-y-auto" style={{ scrollbarWidth: "thin" }}>
                                        {filteredCustomers.map(c => (
                                            <button
                                                key={c.id}
                                                type="button"
                                                onMouseDown={() => selectCustomer(c)}
                                                className="w-full text-left px-4 py-3 hover:bg-brand-50 dark:hover:bg-navy-700 flex items-center gap-3"
                                            >
                                                <div className="w-8 h-8 rounded-lg bg-brand-500/10 text-brand-600 flex items-center justify-center font-bold text-xs">
                                                    {((c.name || "?")[0]).toUpperCase()}
                                                </div>
                                                <div>
                                                    <div className="font-bold text-sm text-navy-700 dark:text-white">{c.name} {c.surname}</div>
                                                    {c.phone && <div className="text-xs text-gray-400">{c.phone}</div>}
                                                </div>
                                            </button>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Not */}
                    <div>
                        <label className="block text-xs font-bold text-gray-500 dark:text-gray-400 uppercase tracking-wide mb-2">Not</label>
                        <textarea
                            rows={2}
                            value={quickForm.note}
                            onChange={e => setQuickForm({ ...quickForm, note: e.target.value })}
                            placeholder="Ek notlar..."
                            className="w-full bg-white dark:bg-navy-900 border border-gray-200 dark:border-navy-600 rounded-xl px-4 py-3 text-sm text-navy-700 dark:text-white outline-none focus:border-brand-500 transition-all resize-none"
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="p-4 bg-gray-50 dark:bg-navy-900 border-t border-gray-100 dark:border-navy-700 flex justify-between items-center gap-3">
                    <button
                        type="button"
                        onClick={onToggleBreak}
                        disabled={creating}
                        className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold text-red-500 border border-red-200 dark:border-red-800 hover:bg-red-50 dark:hover:bg-red-900/20 transition-all disabled:opacity-50"
                    >
                        <BsBan size={15}/> Slotu Kapat
                    </button>
                    <div className="flex gap-3">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-5 py-2.5 rounded-xl text-sm font-bold text-gray-500 bg-white dark:bg-navy-800 border border-gray-200 dark:border-navy-600 hover:bg-gray-100 dark:hover:bg-navy-700 transition-all"
                        >
                            Vazgeç
                        </button>
                        <button
                            type="button"
                            onClick={onSubmit}
                            disabled={creating}
                            className="flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold text-white bg-brand-500 hover:bg-brand-600 shadow-lg shadow-brand-500/30 transition-all disabled:opacity-60"
                        >
                            {creating ? (
                                <><div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div> Kaydediliyor...</>
                            ) : (
                                <><FiSave size={15}/> Oluştur</>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuickCreateModal;